import { countries, getEmojiFlag } from 'countries-list';

import { CountryData } from '@/modules/common/types/location';

import { ApiErrorCode, createApiError } from './errors';

/**
 * Retrieves and transforms country data for form selection components.
 * Provides country codes, names, and emoji flags for international organization setup.
 * @returns Array of CountryData with code, name, and flag
 */
export const getCountriesData = async (): Promise<CountryData[]> => {
  try {
    return Object.entries(countries || {}).map(([code, country]) => ({
      code,
      name: country.name,
      flag: getEmojiFlag(code as any),
    }));
  } catch (error) {
    throw createApiError(ApiErrorCode.COUNTRIES_LOAD_FAILED, error);
  }
};
